import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { CRBTUIComponent, CRBTUIComponentProps } from '../../crbt/crbtuicomponent';
import { ArtistSearchListViewImpl } from './artistlistview';
import { ArtistSearchListCSSStyleImpl } from './artistlistcss';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { SearchListAPIModelImpl, SearchListAPIModel } from '../searchlistapimodel';

export interface ArtistSearchListComponentProps extends CRBTUIComponentProps
{
   searchKey: string;
}

export interface ArtistSearchListComponentHandler extends UIComponentHandler
{
    loadMoreTones(startIndex: number, offset: number): void;
    onDataNotLoaded(isNotLoaded: boolean): void;
}
export interface ArtistSearchListComponenState extends UIComponentState
{
    isDataNotLoaded: boolean;
 
}
export class ArtistSearchListComponent extends CRBTUIComponent<ArtistSearchListComponentProps, ArtistSearchListComponenState> 
implements ArtistSearchListComponentHandler
{
    private isOnLoadMore: boolean;
    constructor(props: ArtistSearchListComponentProps)
    {
        super(props);
    
        this.state ={isDataNotLoaded:false};
    }

   componentDidMount()
    {
        this.loadMoreTones = this.loadMoreTones.bind(this);
        (this.getView() as ArtistSearchListViewImpl).showLoader();
        this.getAPIModel().getArtistSearchTone(0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), this.props.searchKey);
    }

    componentWillReceiveProps(nextProps: ArtistSearchListComponentProps)
    {
        this.isOnLoadMore = false;
        (this.getView() as ArtistSearchListViewImpl).showLoader();
        (this.getView() as ArtistSearchListViewImpl).setListOfDatas([]);
      
        this.setState({isDataNotLoaded: false});
         
        this.getAPIModel().getArtistSearchTone(0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), nextProps.searchKey);
    }

   
    onDataNotLoaded(isNotLoaded: boolean): void {
        this.setState({isDataNotLoaded: isNotLoaded});
      }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        // return new ArtistSearchListViewImpl(10, applicationContext, uiComponentHandler);
        return new ArtistSearchListViewImpl(this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ArtistSearchListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new SearchListAPIModelImpl(applicationContext, apiModelHandler);
    }

    loadMoreTones(startIndex: number, offset: number): void 
    {
        this.isOnLoadMore = true;
        (this.getView() as ArtistSearchListViewImpl).showLoader();
        this.getAPIModel().getArtistSearchTone(startIndex, offset, this.props.searchKey);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ArtistSearchListViewImpl).setListOfDatas(data as ToneDto[]);
        (this.getView() as ArtistSearchListViewImpl).dismissLoader();
        (this.getView() as ArtistSearchListViewImpl).updatePagination(this.isOnLoadMore);
        
        this.setState({ isDataNotLoaded:   (this.getView() as ArtistSearchListViewImpl).getListOfDatas().length > 0 ? false :  true});
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as ArtistSearchListViewImpl).dismissLoader();
        (this.getView() as ArtistSearchListViewImpl).getListOfDatas().length = 0;

        if(!this.isOnLoadMore)
        {
            this.setState({isDataNotLoaded: true});
        }
    }
    getAPIModel(): SearchListAPIModel
    {
        return (super.getAPIModel() as SearchListAPIModel);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/searchlist/artist/artistlistcomponent.tsx